import { styled, Box } from '@mui/material';
import theme from '../theme';
import DropdownNormal from '../components/dropdown/DropdownNormal';

const d_block = { display: 'block' };

const d_flex = { display: 'flex' };

const d_flex_center = { display: 'flex', alignItems: 'center', justifyContent: 'center' };

const d_flex_space_between = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' };

const d_flex_space_evenly = { display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' };

const d_flex_space_around = { display: 'flex', alignItems: 'center', justifyContent: 'space-around' };

const d_flex_start = { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' };

const d_flex_end = { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' };

const ignore_drag = { userSelect: 'none', msUserSelect: 'none', MozUserSelect: 'none', WebkitUserSelect: 'none' };

interface FlexDirection {
  flexDirection: 'row' | 'column';
}

interface StyledUtilWrapProps {
  $marginTop?: string;
  $width?: string;
}

interface StyledDirectionProps {
  $width: string;
  $direction?: string;
}

const dir_row: FlexDirection = { flexDirection: 'row' };

const dir_column: FlexDirection = { flexDirection: 'column' };

const Deco = styled(Box)({
  display: 'inline-block',
  marginRight: '0.5rem',
  borderLeft: `1px dotted ${theme.palette.gray_1.main}`,
  borderBottom: `1px dotted ${theme.palette.gray_1.main}`,
  transform: 'translateY(-50%)',
});

interface BarProps {
  $bgColor?: string;
  $marginLeft?: boolean;
}

export const Bar = styled(Box)<BarProps>(props => ({
  width: '2px',
  height: '1rem',
  marginRight: '0.5rem',
  marginLeft: props.$marginLeft ? '0.5rem' : '',
  backgroundColor: props.$bgColor ? props.theme.palette[props.$bgColor].main : props.theme.palette.black.main,
}));

interface BorderProps {
  $borderWidth: string;
  $borderStyle: string;
  $borderColor: string;
}

export const Border = styled(Box)<BorderProps>(props => ({
  borderWidth: props.$borderWidth,
  borderStyle: props.$borderStyle,
  borderColor: props.theme.palette[props.$borderColor].main,
}));

// ModalCheck, ModalConfirm Style 같은 부분들 존재해서 한 번만 작성후 가져다 사용하는 것으로 세팅
interface StyledModalWrapperProps {
  height?: string;
}
const StyledModalWrapper = styled(Box)<StyledModalWrapperProps>(props => ({
  maxWidth: '480px',
  width: '35.7rem',
  borderRadius: '4px',
  lineHeight: '2rem',
  backgroundColor: props.theme.palette.white.main,
  ...d_flex_center,
  ...dir_column,
}));

const StyledModalTitle = styled(Box)(props => ({
  width: '100%',
  [props.theme.breakpoints.up('xxl')]: {
    fontSize: '1.1rem',
  },
  [props.theme.breakpoints.down('xxl')]: {
    fontSize: '1.2rem',
  },
  '.delete_contents, .delete_contents b': {
    [props.theme.breakpoints.up('xxl')]: {
      fontSize: '1.1rem',
    },
    [props.theme.breakpoints.down('xxl')]: {
      fontSize: '1.2rem',
    },
  },
  '.delete_contents b': {
    fontWeight: 'bold',
  },
  whiteSpace: 'pre-wrap',
  textAlign: 'center',
  color: 'rgba(0, 0, 0, 0.87)',
  padding: '32px 16px',
  ...d_flex_center,
  ...dir_column,
  '& > span': {
    '&:last-of-type': {
      fontSize: '1rem',
      lineHeight: '1.45rem',
    },
  },
}));

const StyledModalUtil = styled(Box)(props => ({
  width: '100%',
  height: '52px',
  borderTop: `1px solid ${props.theme.palette.gray_3.main}`,
  ...d_flex_center,
}));

const StyledLine = styled(Box)(props => ({
  width: '1px',
  height: '100%',
  backgroundColor: props.theme.palette.gray_3.main,
}));

const StyledDropdownNormal = styled(DropdownNormal)(() => ({
  backgroundColor: '#00bfff',
  color: '#ffffff',
  // border: 'none',
  '&:hover': {
    backgroundColor: '#00bfff !important',
  },
}));

const StyledUtilWrap = styled(Box)<StyledUtilWrapProps>(props => {
  return {
    width: props.$width ? props.$width : '100%',
    height: '2.5rem',
    marginBottom: '0.5rem',
    marginTop: props.marginTop === 'true' ? '0.5rem' : '0',
    ...d_flex_space_between,

    '.regi': {
      '&.edit-page': {
        position: 'fixed',
        top: 'calc(9.5rem + 8px)',
        height: '2.5rem',
        '&.student': {
          top: 'calc(12.5rem)',
        },
      },
    },
    '.require_text': {
      position: 'fixed',
      height: '2.5rem',
      top: 'calc(12.5rem)',
      width: '100%',
    },
    '.scroll_box': {
      position: 'fixed',
      height: '3rem',
      width: '3rem',
      bottom: '12px',
      right: '12px',

      '& > div': {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: '#fafafa',
        border: '1px solid',
        borderColor: '#e4e4e4',
        borderRadius: '4px',
        fontSize: '0.9rem',
        cursor: 'pointer',

        svg: {
          marginTop: '-0.2rem',
          width: '1rem',
          height: '1rem',
          strokeWidth: 0.5,
        },
      },
    },
  };
});

const StyledUtil = styled(Box)<StyledDirectionProps>(props => ({
  width: props.$width,
  height: '100%',
  alignItems: 'center',
  justifyContent: props.$direction === 'left' ? 'flex-start' : 'flex-end',
  ...d_flex,
}));

const CloseButton = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  right: '1.2rem',
  zIndex: 2,
  backgroundColor: '#c9c9c9',
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  padding: 0,
  cursor: 'pointer',
  svg: {
    width: '1.7rem',
    height: '1.7rem',
    strokeWidth: 30,
  },

  ...d_flex_center,
}));

const magazine_subject_colors = [
  {
    id: '10',
    color: '#FF453B',
  },
  {
    id: '20',
    color: '#FF7C26',
  },
  {
    id: '30',
    color: '#FFB22D',
  },
  {
    id: '40',
    color: '#3ACA4E',
  },
  {
    id: '50',
    color: '#2F6BC1',
  },
  {
    id: '60',
    color: '#BF5EFB',
  },
];

export {
  d_block,
  d_flex,
  d_flex_center,
  d_flex_start,
  d_flex_end,
  d_flex_space_between,
  d_flex_space_evenly,
  d_flex_space_around,
  ignore_drag,
  dir_row,
  dir_column,
  Deco,
  StyledModalWrapper,
  StyledModalTitle,
  StyledModalUtil,
  StyledLine,
  StyledUtilWrap,
  StyledDropdownNormal,
  StyledUtil,
  CloseButton,
  magazine_subject_colors,
};
